import { Category } from '../../components/promo/utils/determineCategory';

export const EXPERT_COMPTABLE = {
    title: 'Expert-comptable',
    links: [
        {
            label: 'Expertise comptable',
            url: '/expert-comptable',
        },
        {
            label: 'Fiche de paie en ligne',
            url: '/fiches-de-paie-en-ligne',
        },
        {
            label: 'Conseil juridique',
            url: '/conseil-juridique',
        },
        {
            label: 'Logiciel de facturation',
            url: '/logiciel-facturation-gratuit',
        },
        {
            label: 'Bilan liasse fiscale',
            url: '/bilan-liasse-fiscale',
        },
        {
            label: 'Synchronisation bancaire',
            url: '/synchronisation-bancaire',
        },
        {
            label: 'Performances en temps réel',
            url: '/performances-en-temps-reel',
        },
        {
            label: 'Note de frais',
            url: '/note-de-frais',
        },
        {
            label: 'Toutes nos fonctionnalités',
            url: '/fonctionnalites',
        },
        {
            label: 'Expert-comptable freelance',
            url: '/expert-comptable-freelance',
        },
        {
            label: 'Expert-comptable TPE',
            url: '/expert-comptable-tpe',
        },
        {
            label: 'Expert-comptable artisan',
            url: '/expert-comptable-artisan',
        },
        {
            label: 'Expert-comptable e-commerce',
            url: '/expert-comptable-ecommerce',
        },
        {
            label: 'Expert-comptable profession libéral',
            url: '/expert-comptable-freelance',
        },
    ],
};

export const CREATION_ENTREPRISE = {
    title: "Création d'entreprise",
    links: [
        {
            label: 'Créer votre entreprise',
            url: '/creation-entreprise',
        },
        {
            label: 'Création SASU',
            url: '/creer-sasu',
        },
        {
            label: 'Création SAS',
            url: '/creer-sas',
        },
        {
            label: 'Création SARL',
            url: '/creer-sarl',
        },
        {
            label: 'Création EURL',
            url: '/creer-eurl',
        },
        {
            label: 'Création SCI',
            url: '/creer-sci',
        },
        {
            label: 'Création HOLDING',
            url: '/creer-holding',
        },
    ],
};

export const RESSOURCES = {
    title: 'Ressources',
    links: [
        {
            label: 'Webinars',
            url: '/webinars',
        },
        {
            label: 'Guides',
            url: '/guides',
        },
        {
            label: 'Simulateurs - Page 1',
            url: '/simulateurs',
        },
        {
            label: 'Simulateurs - Page 2',
            url: '/simulateurs/page/2/',
        },
        {
            label: 'Témoignages',
            url: '/avis-temoignages',
        },
        {
            label: 'Road to Business',
            url: '/road-to-business',
        },
        {
            label: 'Vidéo de démonstration',
            url: '/demo',
        },
        {
            label: 'Presse',
            url: '/presse',
        },
    ],
};

export const LIENS_UTILES = {
    title: 'Liens utiles',
    links: [
        {
            label: 'Tarifs',
            url: '/tarifs',
        },
        {
            label: 'Contact',
            url: '/contact',
        },
        {
            label: 'Dougs Academy',
            url: 'https://formation.dougs.fr/',
        },
        {
            label: 'Parrainage',
            url: '/dougs-parrainage',
        },
        {
            label: 'FAQ',
            url: '/faq',
        },
        {
            label: 'Cas client',
            url: '/cas-client',
        },
        {
            label: 'Jobs',
            url: '/jobs',
        },
        {
            label: 'Équipe',
            url: '/equipe',
        },
    ],
};

export const SIGN_UP_LINK = {
    crea: {
        url: 'https://app.dougs.fr/app/signup?s=creation',
    },
    facturation: {
        url: 'https://app.dougs.fr/app/signup?s=invoicing',
    },
    compta: {
        url: 'https://app.dougs.fr/app/signup?s=accounting',
    },
} as Record<Category, { url: string }>;

export const DEFAULT_SIGN_UP_LINK = 'https://app.dougs.fr/app/signup';
export const DEFAULT_SIGN_IN_LINK = 'https://app.dougs.fr/app/signin';
